var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPound = function SvgPound(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none!important",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.817 18H11.49a.167.167 0 0 1-.167-.162c0-.028.006-.057.02-.082a4.157 4.157 0 0 0 .475-1.937v-2.334a.167.167 0 0 1 .167-.166h4.558a1 1 0 0 0 0-2h-4.558a.167.167 0 0 1-.167-.167V8.5a2.5 2.5 0 1 1 5 0 1 1 0 0 0 2 0 4.5 4.5 0 1 0-9 0v2.652a.167.167 0 0 1-.166.167H7a1 1 0 1 0 0 2h2.65a.165.165 0 0 1 .155.102c.008.02.012.042.012.064v2.334A2.183 2.183 0 0 1 7.636 18a1 1 0 0 0 0 2h10.181a1 1 0 1 0 0-2z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPound);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "pound.c0687d40efcf3e5b5013f5e29121980d.svg";